import Comment from "components/Cards/Comment"
import Feadback from "components/Cards/Feadback"
import Spinner from "components/Spinner/FullScreen"
import { useHideModal, useShowModal } from "hooks"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { FiArrowLeft } from "react-icons/fi"
import { useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import works from "services/works"
import FormFeedback from "./FormFeedback"

export default () => {
  const [loading, setLoading] = useState(true)
  const [feedback, setFeedback] = useState({})
  const [selectedRate, setSelectedRate] = useState(0)
  const { token, photo, username } = useSelector(
    (state) => state.userDatasReducer
  )
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [stars, setStars] = useState({
    1: 0,
    2: 0,
    3: 0,
    4: 0,
    5: 0,
  })
  const [averageRate, setAverageRate] = useState(0)
  const { showBlured } = useShowModal()
  const { hideModal } = useHideModal()
  const { id } = useParams()
  const fetchWork = () => {
    works
      .getOne(id)
      .then((resp) => {
        setFeedback(resp)
        const foo = resp?.comments.reduce((acc, val) => {
          if (val?.rate in acc && val?.rate > 0) {
            acc[val?.rate]++
          } else {
            if (val?.rate > 0) {
              acc[val?.rate] = 1
            }
          }
          return acc
        }, {})
        const rates = resp?.comments?.reduce((acc, comment) => {
          return acc + comment.rate
        }, 0)
        setStars((prev) => ({ ...prev, ...foo }))
        if (rates) {
          setAverageRate(() => rates / resp?.comments.length)
        }
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false))
  }
  useEffect(() => {
    if (id) {
      fetchWork()
    }
  }, [id])

  if (loading) {
    return <Spinner />
  }
  const handleSetComment = (rate, message) => {
    const reqBody = {
      comment: {
        fullName: username,
        rate,
        comment: message,
        rateDate: new Date(),
        photo,
      },
    }
    if (rate && message) {
      setLoading(true)
      setSelectedRate(() => rate)
      works
        .update(id, reqBody)
        .then(() => {
          fetchWork()
        })
        .catch((err) => console.error(err))
        .finally(() => {
          setLoading(false)
          hideModal()
        })
    }
  }

  const openCommentForm = () => {
    if (token) {
      showBlured({
        title: "Бажарилган иш бўйича фикр билдириш",
        maxWidth: "800px",
        height: "400px",
        withHeader: false,
        button: false,
        rounded: true,
        body: () => (
          <FormFeedback
            handleSetComment={handleSetComment}
            cancel={hideModal}
          />
        ),
      })
    } else {
      navigate("/auth")
    }
  }

  return (
    <div className="w-full lg:w-3/4 lg:max-w-[70%] md:w-7/12 font-[Roboto]">
      <div className="py-4 pb-10">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center justify-start gap-1 text-base text-black"
        >
          <FiArrowLeft size={20} />
          {t("back")}
        </button>
      </div>
      <div>
        <Feadback
          data={feedback}
          selectedRate={selectedRate}
          handleSetComment={handleSetComment}
          openCommentForm={openCommentForm}
          stars={stars}
          averageRate={averageRate}
        />
      </div>
      <div className="py-4 pt-10 text-black lg:py-10 lg:pt-20">
        <h4 className="text-lg font-medium">{t("comments")}:</h4>
        {feedback?.comments?.length > 0 ? (
          <Comment data={feedback} />
        ) : (
          <div className="w-full h-full text-base text-secondary-text-color">
            {t("no-comment")}...
          </div>
        )}
      </div>
    </div>
  )
}
